// extracted by mini-css-extract-plugin
export default {"body":"admin_body__jQpn4","header":"admin_header__bklFx"};